<script>
  import { getPageEnumList } from '../../../../../api/marketing/advertising'

  export default {
    name: 'AdGroupForm',
    props: {
      value: {
        type: Object,
        default: () => ({
          name: '',
          templateId: '',
          sort: 0
        })
      },
      isEdit: {
        type: Boolean,
        default: false
      },
      // 是否简化模式（用于图5的场景）
      isSimpleMode: {
        type: Boolean,
        default: false
      },
      bannerTemplates: {
        type: Array,
        default: () => []
      },
      // 是否允许缓存表单数据
      allowCache: {
        type: Boolean,
        default: false
      }
    },
    model: {
      prop: 'value',
      event: 'change'
    },
    data() {
      return {
        // form: {
        //   name: '',
        //   templateId: '',
        //   weights: 0
        // },
        rules: {
          name: [
            { required: true, message: '请输入广告组名称', trigger: 'blur' },
            { max: 10, message: '不超过10个字符', trigger: 'blur' },
            {
              validator: (rule, value, callback) => {
                if (!value) {
                  callback()
                  return
                }

                // 使用更精确的表情符号检测方法
                // 这个正则表达式专门匹配表情符号，不会误判数字
                const emojiRegex =
                  /[\u{1F300}-\u{1F5FF}\u{1F600}-\u{1F64F}\u{1F680}-\u{1F6FF}\u{1F700}-\u{1F77F}\u{1F780}-\u{1F7FF}\u{1F800}-\u{1F8FF}\u{1F900}-\u{1F9FF}\u{1FA00}-\u{1FA6F}\u{1FA70}-\u{1FAFF}\u{2600}-\u{26FF}\u{2700}-\u{27BF}]/u

                if (emojiRegex.test(value)) {
                  callback(new Error('名称不能包含表情符号'))
                  return
                }

                callback()
              },
              trigger: ['blur', 'change']
            }
          ],
          templateId: [{ required: true, message: '请选择banner模板', trigger: 'change' }],
          displayPage: [{ required: true, message: '请选择展示页面', trigger: 'change' }],
          weights: [
            { required: true, message: '请输入权重', trigger: ['blur', 'change'] },
            {
              pattern: /^(?:[1-9]|10)$/,
              message: '请输入小于等于10的正整数',
              trigger: ['blur', 'change']
            }
          ]
        },
        pageEnumList: [],
        isInitialized: false
      }
    },
    created() {
      this.initForm()
      getPageEnumList().then((res) => {
        const { code, data } = res
        if (code === 0) {
          this.pageEnumList = data.bannerDisplayPage || []
        }
      })

      this.$nextTick(() => {
        setTimeout(() => {
          this.isInitialized = true
          console.log('AdGroupForm initialized')
        }, 100)
      })
    },
    computed: {
      form: {
        set(val) {
          console.log('数据变化', val)
          this.$emit('change', val)
        },
        get() {
          return this.value
        }
      }
    },
    watch: {
      form: {
        handler(newVal) {
          if (!this.isInitialized || !this.allowCache) return

          const adGroupCache = localStorage.getItem('adGroupCache')
          let newData = {}
          if (adGroupCache) {
            try {
              newData = JSON.parse(adGroupCache)
              newData.baseForm = newVal
            } catch (error) {
              console.error('读取缓存失败:', error)
              newData = {
                baseForm: newVal,
                dataMap: {}
              }
            }
          } else {
            newData = {
              baseForm: newVal,
              dataMap: {}
            }
          }
          localStorage.setItem('adGroupCache', JSON.stringify(newData))
        },
        deep: true
      }
    },
    methods: {
      // 初始化表单
      initForm() {
        if (this.value) {
          this.form = { ...this.value }
        }
      },

      // 校验表单
      validate() {
        return new Promise((resolve, reject) => {
          this.$refs.adGroupForm.validate((valid) => {
            if (valid) {
              resolve(this.form)
            } else {
              reject(new Error('广告组基本信息验证失败'))
            }
          })
        })
      },

      // 处理模板变更
      handleTemplateChange() {
        const template = this.bannerTemplates.find((item) => item.id === this.form.templateId)

        // 更新表单并通知父组件
        this.$emit('change', {
          ...this.form,
          adTemplateName: template ? template.name : '',
          slotKeys: template ? template.slotKeys : []
        })

        // 触发模板变更事件
        this.$emit('template-change', {
          template,
          slotKeys: template ? template.slotKeys : []
        })
      },

      // 重置表单
      resetForm() {
        this.$refs.adGroupForm.resetFields()
      }
    }
  }
</script>

<template>
  <div class="ad-group-form">
    <el-form ref="adGroupForm" :model="form" :rules="rules" label-width="120px" size="small">
      <el-form-item label="广告组名称" prop="name">
        <el-input
          v-model="form.name"
          placeholder="请输入广告组名称"
          maxlength="10"
          show-word-limit
          style="width: 400px"
          v-no-emoji
        />
      </el-form-item>

      <el-form-item label="展示页面" prop="displayPage" v-if="!isSimpleMode">
        <el-select v-model="form.displayPage" placeholder="请选择" clearable style="width: 400px">
          <el-option
            v-for="item in pageEnumList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-form-item>

      <el-form-item label="权重" prop="weights">
        <div style="display: flex; align-items: center">
          <el-input-number v-model="form.weights" :min="1" :max="10" />
          <span class="form-tip" style="width: 450px"> 权重数值越小越靠前，广告组优先级越高 </span>
        </div>
      </el-form-item>

      <el-form-item label="banner 模板" prop="templateId" v-if="!isSimpleMode">
        <div style="display: flex">
          <el-select
            v-model="form.templateId"
            placeholder="请选择banner模板"
            style="width: 400px"
            @change="handleTemplateChange"
            :disabled="isEdit"
          >
            <el-option
              v-for="item in bannerTemplates"
              :key="item.id"
              :label="item.name"
              :value="item.id"
              :disabled="!item.selected"
            >
              <div style="padding: 0 20px">
                {{ item.name
                }}<span v-if="!item.selected" style="color: red; margin-left: 10px"
                  >(未配置默认banner)</span
                >
              </div>
            </el-option>
          </el-select>
          <div v-if="isEdit">{{ form.adTemplateName }}</div>
          <div class="form-tip" style="width: 450px"> 选用模板前需配置默认 banner </div>
        </div>
      </el-form-item>
    </el-form>
  </div>
</template>

<style scoped lang="scss">
  .ad-group-form {
    margin-bottom: 20px;
  }

  .form-tip {
    font-size: 12px;
    color: red;
    line-height: 1.5;
    margin-left: 10px;
  }
</style>
